const selfSelector = (state) => state.orderBar

export default selfSelector
